export enum CreateProjectTemplateActionItemsMethod {
  OneWithAllEntities = "OneWithAllEntities",
  OnePerEntity = "OnePerEntity",
  OneAndHashNoEntitiesField = "OneAndHasNoEntitiesField"
}
